var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.navPermissions['reports'].enable)?_c('b-nav',[_c('b-nav-item',{staticClass:"d-block-custom",attrs:{"to":"/default_home"}},[_c('i',{staticClass:"fa mr-2 fa-file-invoice text-danger",attrs:{"font-scale":"1"}}),_vm._v("Reports\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }